// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";

type Props = {
  classes: Object,
  children: any,
};

const HomeBlogContainer = ({ classes, children }: Props) => (
  <div className={classes.root}>{children}</div>
);

const styles = (theme) => ({
  root: {
    padding: "42px 12px",
    backgroundColor: "white",

    [theme.breakpoints(600)]: {
      padding: "42px 80px",
    },
  },
});

export default withStyles(styles, { name: "HomeBlogContainer" })(
  HomeBlogContainer
);
